import "./App.css";
// import HeroSection from "./HeroSection";
import Navbar from "./Navbar";
import GallerySection from "./GallerySection";
import Footer from "./Footer";

function App() {
  return (
    <div className="App bg-[#0A0A0A]  items-center flex flex-col ">
      <Navbar></Navbar>
      <GallerySection></GallerySection>
      <Footer></Footer>
    </div>
  );
}

export default App;
